import { preFormat, postFormat } from './file-with-type'

export default {
  type: 'Audio',
  preFormat: (fieldValues, Type) => {
    return preFormat(fieldValues, Type, 'Audio')
  },
  postFormat: (fieldValues, Type) => {
    return postFormat(fieldValues, Type, 'Audio')
  },
}
